import { render } from "./footer.vue?vue&type=template&id=3d7fde06"
const script = {}

import exportComponent from "/var/www/tradechallenge_prd/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__